import { HashupGameUploader as HashupGameUploaderWC } from 'hashup-game-uploader';
import { createComponent, EventName } from '@lit-labs/react';
import React from 'react';
import * as Sentry from '@sentry/react';

interface EventUploaded extends Event {
	detail: {
		download_links: {
			indirect: string;
			direct: string;
		};
		id: number;
	};
}

export const HashupGameUploader = Sentry.withProfiler(
	createComponent(React, 'hashup-game-uploader', HashupGameUploaderWC, {
		fileUploaded: 'file-uploaded' as EventName<EventUploaded>,
	})
);
